/**
 * Sprint 15 Ola 7 — AuriaTriageInjury
 * Body zone selector for injury triage.
 * Props: onBodyZoneSelect(zone), onBack()
 */

import React from 'react'

const BODY_ZONES = [
  { label: 'Hombro / Manguito', zone: 'shoulder' },
  { label: 'Codo / Epicóndilo', zone: 'elbow' },
  { label: 'Lumbar / Espalda baja', zone: 'lumbar' },
  { label: 'Isquiotibial', zone: 'hamstring' },
  { label: 'Rodilla / Rótula', zone: 'knee' },
  { label: 'Cuádriceps', zone: 'quadriceps' },
  { label: 'Gemelo / Sóleo', zone: 'calf' },
  { label: 'Tobillo / LCAE', zone: 'ankle' },
  { label: 'Aductor / Pubis', zone: 'groin' },
]

export default function AuriaTriageInjury({ onBodyZoneSelect, onBack }) {
  return (
    <div
      data-testid="auria-triage-injury"
      style={{ padding: '12px 16px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, gap: 8 }}>
        <button
          onClick={onBack}
          data-testid="injury-back"
          style={{
            padding: '6px 12px',
            borderRadius: 8,
            border: '1px solid var(--border, #e0ddd8)',
            background: 'transparent',
            color: 'var(--pl-ink)',
            fontSize: 13,
            cursor: 'pointer',
            fontFamily: 'var(--font-sans, system-ui, sans-serif)',
          }}
        >
          ← Volver
        </button>
        <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--pl-ink)' }}>
          ¿Dónde tienes la molestia?
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        {BODY_ZONES.map(({ label, zone }) => (
          <button
            key={zone}
            data-testid={`injury-zone-${zone}`}
            onClick={() => onBodyZoneSelect && onBodyZoneSelect(zone)}
            style={{
              padding: '10px 16px',
              borderRadius: 20,
              border: '1.5px solid var(--prime-terracota, #c0715a)',
              background: 'var(--bg-elevated, #f5f3ef)',
              color: 'var(--prime-terracota, #c0715a)',
              fontSize: 13,
              fontWeight: 500,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              fontFamily: 'var(--font-sans, system-ui, sans-serif)',
              transition: 'background 0.15s',
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
